import { useContext, useState } from 'react';
import { PlacesContext, MapContext } from '../context';
import { Feature } from '../interfaces/places';
import { LoadingPlaces } from './';


export const SearchResults = () => {

  const { map, getRouteBetweenPoints } = useContext( MapContext );
  const { places, isLoadingPlaces, userLocation } = useContext(PlacesContext);
  const [activeId, setActiveId] = useState('');

  if( isLoadingPlaces ) return <LoadingPlaces />
  if( places.length === 0 ) return <></>

  const flyTo = (place: Feature) => {

    setActiveId(place.id);

    const [ lng, lat ] = place.center;
    map?.flyTo({
      zoom: 14,
      center: [lng, lat]
    })

    
  }

  const getRoute = (place: Feature) => {
    const [ lng, lat ] = place.center;
    getRouteBetweenPoints( userLocation!, [ lng, lat ] )
  }

  return (
    <ul className="list-group mt-3">

      {
        places.map(place => (
          <li
            onClick = {() => flyTo(place) }
            key={ place.id }
            className={`${ activeId === place.id && 'active' } list-group-item list-group-item-action`}
            style={{ cursor: 'pointer' }}
          >
            <h6>{ place.text_es }</h6>
            <p style={{ fontSize: '12px' }}>
              { place.place_name }
            </p>

            <button 
              className={`btn btn-sm ${ activeId === place.id ? 'btn-outline-light': 'btn-outline-primary' }`}
              onClick={ () => getRoute(place) }
            >
              Direcciones
            </button>
          </li>
        ))
      }

      
    </ul>
  )
}
